import { render, staticRenderFns } from "./TermsDropdown.vue?vue&type=template&id=5dbd4dc5&"
import script from "./TermsDropdown.vue?vue&type=script&lang=js&"
export * from "./TermsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports